module.exports = __webpack_public_path__ + "img/otamerica_mx_english_2023_certification_badge.6cbb30f3.png";